import {
  analyticsVideoTypes,
  eventAction,
  eventObject,
  videoPlayerNames,
} from '@/constants/analytics'
import { YOUTUBE_VIDEO_ID_REGEXP, ytUrl } from '@/constants/common'
import { usePPVPopupStore } from '@/store/usePPVPopupStore'
import useStore from '@/store/useStore'
import { AnalyticsEventType } from '@/types'
import {
  EventType,
  eventTypes,
  ListPopupType,
  VideoSourceType,
} from '@/types/servicesTypes/configTypes'
import { getEpgObject, sendAnalyticsEvent } from '@/utils/analyticsUtils'
import { getMediaVideo, getYouTubeVideo } from '@/utils/eventUtils'

export const openEventVideo = (
  event: EventType,
  eventVideoSources?: Nullable<VideoSourceType[]>,
  listOptions?: ListPopupType,
) => {
  const { setMediaVideo, setYouTubeVideo } = useStore.getState().common
  const setPpvPopup = usePPVPopupStore.getState().setPpvPopup
  const isYouTube = event.type === eventTypes.YOUTUBE

  const video = eventVideoSources?.[0]

  handleVideoAnalyticsEvent({ video, event })
  setPpvPopup(null)

  if (isYouTube) {
    const youTubeVideo = getYouTubeVideo(event)
    return setYouTubeVideo(youTubeVideo)
  }

  if (video) {
    const mediaVideo = getMediaVideo(event, event.type, eventVideoSources)
    return setMediaVideo({ ...mediaVideo, listOptions })
  }
}

export const handleVideoAnalyticsEvent = ({
  video,
  event,
}: {
  video?: VideoSourceType
  event: EventType
}) => {
  const isVod = event.type === eventTypes.VOD
  const isYouTube = event.type === eventTypes.YOUTUBE
  const epg = getEpgObject(event)

  const analyticsEventData: AnalyticsEventType = {
    object: eventObject.VIDEO,
    action: eventAction.START_CLICK,
    video: {
      id: event.id,
      name: event.name || event.id,
      playerName: videoPlayerNames.HLS,
      type: isVod ? analyticsVideoTypes.VOD : analyticsVideoTypes.STREAM,
      link: video?.url,
      length: isVod ? event.endTime - event.startTime : 0,
      partnerIds: event.partnerIds,
      epg,
    },
  }
  const videoData = analyticsEventData.video || {}

  if (isYouTube) {
    const youTubeVideoId = event.id?.replace(YOUTUBE_VIDEO_ID_REGEXP, '')
    videoData.playerName = videoPlayerNames.YOUTUBE
    videoData.type = event.live
      ? analyticsVideoTypes.STREAM
      : analyticsVideoTypes.VOD
    videoData.link = `${ytUrl}${youTubeVideoId}`
    videoData.length = !event.live ? event.endTime - event.startTime : 0

    return sendAnalyticsEvent(analyticsEventData)
  }

  if (video) {
    return sendAnalyticsEvent(analyticsEventData)
  }
}
